import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { NavController } from '@ionic/angular/standalone';
import { StateService } from 'src/app/services/state.service';
import { OrderCardComponent } from '../order-card/order-card.component';
import { Order } from '@chemist2u/types-client/C2U/ParseObjects/index.client';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-order-wrapper',
    templateUrl: './order-wrapper.component.html',
    styleUrls: ['./order-wrapper.component.scss'],
    imports: [OrderCardComponent]
})
export class OrderWrapperComponent implements OnInit, OnDestroy {
  private $state = inject(StateService);
  private navController = inject(NavController);
  
  public orders = signal<Order[]>([]);
  public activeOrders = signal<Order[]>([])

  private ordersSub?: Subscription;

  ngOnInit() {
    this.ordersSub = this.$state.bOrders.subscribe(orders => {
      this.orders.set(orders);
      this.setActiveOrders();
    })
  }

  ngOnDestroy() {
    if (this.ordersSub) this.ordersSub.unsubscribe();
  }

  setActiveOrders() {
    const filteredOrders = this.orders()?.filter((order: Order) => 
      order.status !== 'Delivered' && order.status !== 'Cancelled' && order.status !== 'Completed'
    ) || [];

    const activeOrders = filteredOrders.sort((a: Order, b: Order) => {
      if (a.status === 'Ready' && b.status !== 'Ready') {
        return -1; // a comes before b
      }
      if (a.status !== 'Ready' && b.status === 'Ready') {
        return 1; // b comes before a
      }
      return 0; // no change in order
    });

    this.activeOrders.set(activeOrders);
  }

  goToOrder(order: Order) {
    this.navController.navigateForward(`/order/${order.id}`, { queryParams: { returnURL: '/tabs/home' }, state: { order }});
  }

}